export const texts = {
    erreurTechnique: "Il semblerait qu'une erreur technique se soit produite.",
    boutonLienAccueil: "Retourner à la page d'accueil",
    oups: "Oups ...",
}
